import React from "react";
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
// import Button from "@material-ui/core/Button";
// import dateformat from 'dateformat';
// import "./Monthpicker.css";
import Labelbox from "../../../helpers/labelbox/labelbox";
import moment from "moment";
// import Moment from 'moment/min/moment-with-locales';

export default class Monthpicker extends React.Component {

    state = {
        item: [{
            startDate: this.props.startDate? this.props.startDate: '',
            endDate: this.props.endDate? this.props.endDate:'',
        }],
        selectedMonth: this.props.s_month ? this.props.s_month : '',
        openDateRange: false,
        SelectRange:''
    }
    
handleMonthChange = (event) => {
    const selectedMonthEvent = event.target.value; 
     if(event !==''){
    const selectedMonth1 = moment(selectedMonthEvent);
    const startOfMonth = selectedMonth1.startOf('month').format('YYYY-MM-DD');
    const endOfMonth = selectedMonth1.endOf('month').format('YYYY-MM-DD');
    this.setState({ selectedMonth:selectedMonthEvent,
             item:[{
                startDate:startOfMonth,
                endDate:endOfMonth
             }] },()=>this.props.rangeDate(this.state.item)); 
    }
 }

    render() {
        // const { t } = this.props;t('select_range')
//         console.log(this.state.item, "rangedate")
        return (
            <div style={{zIndex:"1"}}>
                <div className="rangePicker_Master date-range-mar">
                    <div className="rangePicker_Label">
                        {"Select Month"} :
            </div>
                    <div className="rangePicker_InpputIconAlign" >   
                    <input type="month" id="start" name="start" min="2018-03" value={this.state.selectedMonth}
                    onChange={this.handleMonthChange} />
                    </div>
                </div>
                {this.state.openDateRange && 
                <input type="month" id="start" name="start" min="2018-03" value="2018-05" />
                }
            </div>
        )
    }
}
